import type { ActionSnapshot } from '../types/companion'

interface ActionApprovalBannerProps {
  snapshot: ActionSnapshot
  onApprove: () => void
  onRevert: () => void
}

/**
 * Inline banner shown after Edge AI executes actions.
 * Displays a summary and approve/revert buttons.
 * Shared between CompanionOverlay and any standalone chat panel.
 */
export function ActionApprovalBanner({ snapshot, onApprove, onRevert }: ActionApprovalBannerProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        padding: '8px 12px',
        borderRadius: 8,
        background: 'rgba(30, 58, 108, 0.95)',
        border: '1px solid rgba(59, 130, 246, 0.5)',
        backdropFilter: 'blur(8px)',
        fontSize: 13,
        color: '#e0e7ef',
      }}
    >
      <span style={{ flex: 1, opacity: 0.9 }}>{snapshot.description}</span>
      <button
        onClick={onRevert}
        style={{
          padding: '4px 10px',
          borderRadius: 4,
          border: '1px solid rgba(255, 255, 255, 0.2)',
          background: 'transparent',
          color: 'inherit',
          cursor: 'pointer',
          fontSize: 12,
          whiteSpace: 'nowrap',
        }}
      >
        Undo
      </button>
      <button
        onClick={onApprove}
        style={{
          padding: '4px 10px',
          borderRadius: 4,
          border: 'none',
          background: 'rgba(59, 130, 246, 0.8)',
          color: '#fff',
          cursor: 'pointer',
          fontSize: 12,
          whiteSpace: 'nowrap',
        }}
      >
        Keep Changes
      </button>
    </div>
  )
}
